/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "./utils";
import { Flex, Text } from "@aws-amplify/ui-react";
export default function Validation(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="19px"
      direction="column"
      width="970px"
      height="unset"
      justifyContent="flex-start"
      alignItems="center"
      position="relative"
      padding="0px 0px 0px 0px"
      {...getOverrideProps(overrides, "Validation")}
      {...rest}
    >
      <Text
        fontFamily="Inter"
        fontSize="40px"
        fontWeight="700"
        color="rgba(11,20,31,1)"
        lineHeight="60px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="Truth From Those Who Know "
        {...getOverrideProps(overrides, "Truth From Those Who Know\u00A0")}
      ></Text>
      <Flex
        padding="0px 0px 0px 0px"
        width="970px"
        height="583px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        {...getOverrideProps(overrides, "Testimonials")}
      >
        <Flex
          gap="44px"
          direction="column"
          width="970px"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          position="absolute"
          top="0px"
          left="0px"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "Content")}
        >
          <Text
            fontFamily="MADE SAONARA"
            fontSize="80px"
            fontWeight="400"
            color="rgba(204,164,59,1)"
            lineHeight="80px"
            textAlign="center"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="970px"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="8"
            {...getOverrideProps(overrides, "8")}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="42px"
            fontWeight="300"
            color="rgba(34,66,114,1)"
            lineHeight="56px"
            textAlign="center"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="By using Ikimy's standardized recruitment process, employers can improve their ability to select candidates who are well-suited for their roles by 45%* or more - enhancing overall organizational performance and employee retention."
            {...getOverrideProps(
              overrides,
              "By using Ikimy's standardized recruitment process, employers can improve their ability to select candidates who are well-suited for their roles by\u00A045%* or more - enhancing overall organizational performance and employee retention."
            )}
          ></Text>
          <Text
            fontFamily="Inter"
            fontSize="32px"
            fontWeight="300"
            color="rgba(34,66,114,1)"
            lineHeight="56px"
            textAlign="center"
            display="block"
            direction="column"
            justifyContent="unset"
            width="unset"
            height="unset"
            gap="unset"
            alignItems="unset"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="(International Journal of Social Science And Human Research, 2023)"
            {...getOverrideProps(
              overrides,
              "(International Journal of Social Science And Human Research, 2023)"
            )}
          ></Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
